import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import Spinner from "../components/layout/Spinner";
import { requestFulfillment } from "../actions/fulfillmentAction";
import ScheduleDelivery from "../components/ScheduleDelivery";

class ScheduleDeliveryContainer extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.requestFulfillment(this.props.match.params.id);
  }
  render() {
    const { loading, fulfillment } = this.props;
    // console.log(this.props);

    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <ScheduleDelivery fulfillment={fulfillment} history={history} />
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = state => ({
  fulfillment: state.requestFulfillment.fulfillment,
  loading: state.requestFulfillment.loading
});
const mapDispatchToProps = dispatch => ({
  requestFulfillment: fulfillmentId =>
    dispatch(requestFulfillment(fulfillmentId))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleDeliveryContainer);
